var DeviceSearchTabController = (function () {
    function DeviceSearchTabController() {
    }
    return DeviceSearchTabController;
}());
export var DeviceSearchTabComponent = {
    bindings: {
        icon: '@',
        selected: '<',
        title: '<tabTitle',
    },
    controller: DeviceSearchTabController,
    template: "\n    <div class=\"device-search-tab__content device-search-tab__transclude\"\n         ng-class=\"{ 'device-search-tab__content--active': $ctrl.selected }\"\n         ng-transclude>\n    </div>\n  ",
    transclude: true,
};
